
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Tools from './components/Tools';
import Awards from './components/Awards';
import Contact from './components/Contact';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Tools />
      <Awards />
      <Contact />
      <Footer />
    </div>
  );
}
